module.exports = __webpack_public_path__ + "static/media/icon.394b9758.svg";